<div class="menuBurger menuBurger-{{style}}">
    <a class="menuBurger-root" (click)="menuBurgerToggle()" title="dc_menu" rel="nofollow"></a>
    <div class="menuBurger-cont" [@visibilityChanged]="visiblityState">
        <div class="container">
            <nav class="menuBurger-nav">
                <ng-container *ngIf="elementos && elementos.length>0">
                    <div class="menuBurger-elem" *ngFor="let elemento of elementos">
                        <div class="menuBurger-niv1">
                            <ng-container *ngIf="(elemento.enlaceExterno && elemento.url != '#' || elemento.path || elemento?.pageRouter)">
                                <a 
                                (click)="seleccionItemMenu(elemento)"
                                [ngClass]="(elemento?.seleccionado && elemento.seleccionado) ? 'menuBurger-active ' : '' "
                                title=""
                                [rel]="(elemento?.enlaceExterno && elemento?.url=='#') ? 'nofollow': ''"
                                [target]="(elemento?.target && elemento.target != '') ? elemento.target: ''">
                                    <ng-template [ngTemplateOutlet]="contenidoMenuBurger"></ng-template>                                        
                                </a>
                            </ng-container>
                            <ng-template #contenidoMenuBurger>
                                {{elemento?.nombre}}
                            </ng-template>
                        </div>
                    
                        <div class="row" *ngIf="elemento?.hijos && elemento.hijos.length> 0">
                            <div class="col-lg-10">
                                
                                    <div class="menuBurger-niv2" *ngFor="let hijo of elemento.hijos">
                                        <a 
                                        (click)="seleccionItemMenu(hijo)"
                                        [ngClass]="(hijo?.seleccionado && hijo.seleccionado) ? 'menuBurger-active ' : '' "
                                        title=""
                                        [rel]="(hijo?.enlaceExterno && hijo?.url=='#') ?  'nofollow': ''"
                                        [target]="(hijo?.target && hijo.target != '') ? hijo.target: ''">
                                            {{hijo.nombre}}                                 
                                        </a>

                                    </div>
                                
                            </div>
                        </div>
                        
                    </div>
                </ng-container>   
                <div class="menuBurger-button" *ngIf="buttonCta">
                    <ng-container *ngIf="!configuracionButtonCta.otroUso; else mainHeaderCtaPersonalizado">
                        <neo-main-header-cta (click)="ocultar()"></neo-main-header-cta>
                    </ng-container>
                    <ng-template #mainHeaderCtaPersonalizado>
                        <neo-main-header-cta (click)="ocultar()" [url]="configuracionButtonCta?.url" [path]="configuracionButtonCta?.path"
                            [label]="configuracionButtonCta?.label" [target]="configuracionButtonCta?.target"
                            [iconoClase]="configuracionButtonCta?.iconoClase">
                        </neo-main-header-cta>
                    </ng-template>
                </div>
                <div class="menuBurger-button">
                    <a class="btn btn-secondary" (click)="accederAreaCliente()" [title]="'Accede'">
                        <span>Mi reserva</span>
                    </a>
                </div>
                <ng-template [ngTemplateOutlet]="customProyeccion || defaultTemplate">
                </ng-template>
                <ng-template #defaultTemplate></ng-template>
                <!-- [ngTemplateOutletContext]="{trackByWeekDayHeaderDate: trackByWeekDayHeaderDate}" -->                 
            </nav>
            <div class="menuBurger-social" *ngIf="menuSocial">
                menu social
            </div>
        </div>
    </div>
</div>

<neo-proximamente-dlg [tituloDialog]="'proximamente_dlg_tit' | transloco"
    [descripcionDialog]="'proximamente_dlg_txt' | transloco">
</neo-proximamente-dlg>
